// 구인구직 게시판이 세션에 기억하는 탭 — 보던 탭(jobs.mode)과 '역할 기본 탭을 이미 적용한 활동유형'(jobs.mode.role).
//  로그인·로그아웃 때 지운다. 남겨 두면 같은 앱에서 다른 원장 계정으로 들어왔을 때
//  첫 진입 기본값(원장=구직)이 적용되지 않고 앞 계정이 보던 탭이 이어졌다(2026-10-22).
export const JOB_MODE_KEY = "jobs.mode";
export const JOB_MODE_ROLE_KEY = "jobs.mode.role";

export function clearJobBoardTabMemory() {
  try {
    sessionStorage.removeItem(JOB_MODE_KEY);
    sessionStorage.removeItem(JOB_MODE_ROLE_KEY);
  } catch (e) { /* 저장소를 못 쓰는 환경 */ }
}
